import React from 'react';
import { constants } from '../../../config';
import { Product, Picture } from '../../../data/models/product_list_response';
import placeholder from '../../../assets/placeholder/product_placeholder.png';
import { capitalize, formatAmount } from '../../../utility/common';
import { ImageComponent } from '../common/image_component';
import { ProductAddButton } from './product_add_button';
import { ProductVariantAddButton } from './product_variant_add_button';

export const SearchProductCard = (product: Product) => {
  let url = placeholder;
  const getImageUrl = (files: Picture[]) => {
    if (files != null) {
      if(files.length > 0){
      const file = files[0];
      url = `${constants.API}/media/MediaContent?filePath=${file.filePath}&fileName=${file.fileName}`;}
    }
    return url;
  };

  return (
    <figure className="p-6 flex flex-row justify-between">
      <div className="flex flex-row">
        <ImageComponent
          src={getImageUrl(product?.productPictures)}
          htmlClass="w-28 h-28 rounded-lg"
          htmlAlt="product-image"
        />
        <div className=" pl-4 text-left">
          <h3 className="font-medium line-clamp-2">{capitalize(product?.productName)}</h3>
          <p className="my-2 font-normal text-sm">{`${product?.quantity} ${product?.productUnit?.productUnitName}`}</p>
          <p className="font-medium text-primaryViolet mt-2">{`${formatAmount(product?.sellingPrice)}`}</p>
        </div>
      </div>
      <div style={{minWidth: '80px'}}>
        <ProductAddButton product={product} isLarge={false} />
      </div>
    </figure>
  );
};
